import { PricingModelTab } from './pricing-model-tab.interface';
import { InvoiceCredit } from '../../credit/interfaces/invoice-credit.interface';
import { AccountingEventType, PaymentOptions } from '../../pricing';
import { CryptoTokens, Currency } from '../enums';
import { UsageProduct } from '../../usage';
import { SyncStatusDto } from '../../integrations';
import { Customer, IntegrationType, Supplier } from './customer.interface';
import { IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { NetTerms } from '../types';
import { DocumentState } from '../documents';

export class PaymentGatewayCustomerDto {
  id: string;
  name: string;
  lastDigits: string; // last 4 digits of the card
  cardBrand: string;

  hasDefaultCard: boolean;

  errors: {
    // indicated that cvc is present and passed
    cvcCheckPassed: boolean;
    expired: boolean;
  } = { cvcCheckPassed: false, expired: false };

  email: string;
}

export class BillingDetailsDto {
  @IsOptional()
  @IsUUID()
  // 'The ID of the billing account for this tab'
  billingAccountId: string | null;

  @IsOptional()
  @IsUUID()
  paymentGatewayId: string | null;

  paymentGateway?: IntegrationType;

  @IsEnum(PaymentOptions)
  @IsOptional()
  paymentOptions: PaymentOptions[];

  @IsOptional()
  @IsString()
  paymentGatewayCustomerId: string | null;

  paymentGatewayCustomer?: PaymentGatewayCustomerDto | null;
}

export class CryptoSettings {
  id?: string;
  address?: string;
  tokens?: CryptoTokens[];
  isEnabled?: boolean;
}

export interface Invoice {
  id?: string;
  documentNumber?: string;
  draftNumber?: string;
  customNumber?: string;
  customerId?: string;
  customer?: Customer;
  contractId?: string;
  contractNumber?: any; //string|number
  poNumber?: string;
  discount?: number;
  submissionDate?: Date; //date
  tax?: number;
  issueDate?: Date | null;
  dueDate?: Date;
  paidDate?: Date;
  createdAt?: Date;
  currency: Currency;
  state?: DocumentState;
  total?: number;
  totalTax?: number;
  subTotal?: number;
  totalDiscount?: number;
  contractPricingModelTabIds?: string[];
  contractPricingModelTabs?: PricingModelTab[];
  invoicePricingModelId?: string;
  pricingModel: any; //PricingModel
  billingEndDate?: Date;
  billingStartDate?: Date;
  totalInSeries?: number;
  numberInSeries?: number;
  totalInSplitInvoice?: number;
  numberInSplitInvoice?: number;
  netTerms?: NetTerms;
  supplierId?: string;
  supplier?: Supplier;
  billingDetails?: Partial<BillingDetailsDto>;
  usageReportsByProduct?: UsageProduct[];
  usageReports?: any[]; //ManualUsageReportItem[]
  relatedUsageProducts?: any[]; //UsageProduct[]
  isCollective?: boolean;
  invoiceCredits?: InvoiceCredit[];
  creditsAmount?: number;
  accountingEventType?: AccountingEventType;
  syncStatus?: SyncStatusDto[];
  cryptoSettings?: CryptoSettings;
}
